var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHappycoins = function SvgHappycoins(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61.915,
    height: 76.008,
    viewBox: "0 0 61.915 76.008",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ILUSTRA",
    transform: "translate(-137.353 -219)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "sombra",
    d: "M25.059,24.734c10.7,0,19.378,2.169,19.378,4.844s-8.677,4.844-19.378,4.844S5.681,32.252,5.681,29.578,14.359,24.734,25.059,24.734Z",
    transform: "translate(144.066 260.586)",
    fill: "rgba(31,26,23,0.2)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "estrela",
    transform: "translate(137.458 218.54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_666",
    "data-name": "Caminho 666",
    d: "M61.915,30.958A30.958,30.958,0,1,1,30.958,0,30.962,30.962,0,0,1,61.915,30.958Z",
    transform: "translate(-0.105 0.46)",
    fill: "#00a6e4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_212690984",
    transform: "translate(19.895 18.46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_212678000",
    d: "M33.8,16.892V22.3c0,2.25-5.143,4.075-11.486,4.075S10.825,24.55,10.825,22.3V16.892",
    transform: "translate(-10.825 -2.001)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_212915960",
    d: "M33.8,14.036v5.408c0,2.25-5.143,4.075-11.486,4.075s-11.486-1.825-11.486-4.075V14.036",
    transform: "translate(-10.825 -4.553)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_212685488",
    d: "M33.8,11.179v5.408c0,2.25-5.143,4.075-11.486,4.075s-11.486-1.825-11.486-4.075V11.179",
    transform: "translate(-10.825 -7.104)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_212676944",
    d: "M22.311,9.027c6.342,0,11.486,1.825,11.486,4.075s-5.143,4.075-11.486,4.075S10.825,15.352,10.825,13.1s5.143-4.075,11.486-4.075Z",
    transform: "translate(-10.825 -9.027)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    fillRule: "evenodd"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHappycoins, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/happycoins.66b8e50f.svg";
export { ForwardRef as ReactComponent };